import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, useRouteMatch, Redirect, useLocation } from "react-router-dom";
import { PagesProvider } from './context/PagesContext';
import Breadcrumbs from '../../UI/Breadcrumbs';
import Loading from '../../Loading';
import PagesList from './pages/PagesList';
import PagesEdit from './pages/PagesEdit';

const PagesSettings = ({event}) => {
    const {path} = useRouteMatch();
    const {pathname} = useLocation();
    const [isPagesLoaded, setPagesLoaded] = useState(false);
    
    return (
        <PagesProvider
            event={event}
            setPagesLoaded={setPagesLoaded}
        >
            {
                isPagesLoaded
                ? <>
                    {
                        !pathname.includes('edit') &&
                        <Breadcrumbs
                            link={`/event/${event.eventPassword}`}
                            activeCrumbs={['mainMenu.pages']}
                        />
                    }
                    <Switch>
                        <Route
                            path={path}
                            exact
                            component={PagesList}
                        />
                        <Route
                            path={`${path}/edit/:pageId`}
                            exact
                            component={PagesEdit}
                        />
                        <Redirect
                            from='*'
                            to={`/event/${event.eventPassword}/pages`}
                        />
                    </Switch>
                </>
                : <Loading />
            }
        </PagesProvider>
    );
}

const mapStateToProps = (store) => {
	return {
		event: store.currentEvent
	};
};

export default connect(mapStateToProps)(PagesSettings);
